import React from 'react';
import { Navigation } from '../components/navigation';
import { Logo } from '../components/logo';
import styled from '@emotion/styled';
import { breakpoints, containerCss } from '../utils/global-styles';

const NavStyled = styled.nav`
  ${containerCss};
  display: flex;
  align-items: center;
`;

const LogoStyled = styled(Logo)`
  margin-right: 20px;
  max-width: 400px;

  @media ${breakpoints.navigationMenu} {
    margin-right: auto;
  }
`;

const NavigationStyled = styled(Navigation)`
  margin-left: auto;
`;

export const NavigationSection = ({
  className,
  scrolled,
}: {
  scrolled: boolean;
  className?: string;
}) => (
  <NavStyled className={className}>
    <LogoStyled></LogoStyled>
  </NavStyled>
);
